import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../lib/requester";
import _ from "lodash";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Autocomplete from "../../component/autocomplete";
import moment from "moment";

class AssignDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      expDate: new Date(),
      principalName: "",
      description: "",
      programType: "",
      autocomplete: "",
      budgetType: "",
      budget: 0,
      salesTarget: 0,
      programMember: "",
      totalParticipant: "",
      participant: [],
      productList: [{ item_id: "", item_desc: "" }],
      documentList: [],
      selectedBranch: [],
      notes: "",
      attachment: [],
      lovBudget: [],
      lovProgramType: [],
      lovDocument: [],
      lovProgramMember: [],
      error: [],
      docContainer: [],
      lovBranch: [],
      success: "",
      memberId: "",
      is_update: false,
      oriParticipant: "",
      memberType: "",
      cabang_id: "",
      customerid: "",
      org_id: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      fileContainer: {},
      submitteddate: "",
      // customerSave:{},
      customerId: 0,
      customerName: 0,
      checkAlready: 0,
      pphRate: "",
      pphType: "",
      lovPPH: [],
      h_name: "",
      h_npwp: "",
      h_address: "",
    };
  }

  componentDidMount = () => {
    // let user = JSON.parse(window.localStorage.getItem('is_user'))
    // let principalName = user.org_name
    // this.setState({ principalName: principalName })
    this.getBranch();
    this.getPPHType();
    // this.getDocumentList()
    this.getProgramMember();
    this.getDetailProgram();
  };

  getDetailProgram = () => {
    let url = "/api/traces/v1/assign/detail";
    let { id } = this.props.match.params;
    let param = {
      program_id: id,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        // let { header, docs, attachment, product, branch } = response.data.data
        // console.log(response.data.data.branch)
        let header = response.data.data.header;
        let docs = response.data.data.docs;
        let attachment = response.data.data.attachment;
        let product = response.data.data.product;
        let branchContainer = response.data.data.branch;
        // let branchContainer = branch.map((item, index) => {
        //     return item.branch_id
        // })

        // let branchContainer = response.data.data.branch.branch_id

        let user = JSON.parse(window.localStorage.getItem("is_user"));
        let idcabang = user.org_id;

        // console.log(user.org_id)

        this.setState({
          cabang_id: idcabang,
          programNumber: header.program_number,
          principalName: header.principal_name,
          ref_number: header.ref_number,
          loading: false,
          description: header.description,
          startDate: new Date(header.start_date),
          endDate: new Date(header.end_date),
          expDate: new Date(header.claim_exp_date),
          programType: header.program_type_id,
          budgetType: header.budget_type_id,
          programMember: header.program_member_id,
          programMember_name: header.member_name,
          memberType: header.member_name,
          budget: header.budget,
          salesTarget: header.sales_target,
          totalParticipant: header.total_participant,
          notes: header.notes,
          docContainer: docs,
          is_update: header.status === "A" ? true : false,
          fileContainer: attachment,
          oriParticipant: header.participant,
          productList: product,
          customerid: header.customer_id,
          selectedBranch: branchContainer,
          org_id: header.org_id,
          submitteddate: moment(header.creation_date).format("DD-MMM-YYYY"),
          pphType: header.pph_type,
          pphRate: header.pph_rate,
        });
        this.getProgramType();
        this.getBudgetType();
        this.getDocumentList();
      }.bind(this),
      error: function (err) {
        // console.log(err)
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getProgramType = () => {
    let url = "/api/traces/v1/general/program-type?orgId=" + this.state.org_id;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramType: response.data.data });
      }.bind(this),
      error: function (e) {
        // console.log(e)
      },
    });
  };

  getProgramMember = () => {
    let url = "/api/traces/v1/general/member-type?orgId=" + this.state.org_id;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovProgramMember: response.data.data });
      }.bind(this),
      error: function (e) {
        // console.log(e)
      },
    });
  };

  getBudgetType = () => {
    let url = "/api/traces/v1/general/budget-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovBudget: response.data.data });
      }.bind(this),
      error: function (e) {
        // console.log(e)
      },
    });
  };

  getDocumentList = () => {
    let url = "/api/traces/v1/general/document-list?orgId=" + this.state.org_id;
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovDocument: response.data.data });
      }.bind(this),
      error: function (e) {
        // console.log(e)
      },
    });
  };

  renderLovPPh = () => {
    return (
      <select
        disabled
        className="form-control"
        name="pphType"
        value={this.state.pphType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Type -</option>
        {this.state.lovPPH.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  getPPHType = () => {
    let url = "/api/traces/v1/general/pph-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPPH: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  renderDocument = () => {
    // console.log(this.state.docContainer)

    return this.state.lovDocument.map((item, index) => (
      <div className="col-md-4" key={index}>
        <div className="form-check">
          <input
            disabled
            className="form-check-input"
            defaultChecked={this.setChecked(item)}
            type="checkbox"
            value={item.document_id}
            id="defaultCheck1"
          />
          <label className="form-check-label" htmlFor="defaultCheck1">
            {item.document_name}
          </label>
        </div>
      </div>
    ));
  };

  getBranch = () => {
    // let url = '/api/orafin/v1/participant/branch'
    // request.getOracle(url, {
    //     success: function (response) {
    //         this.setState({ lovBranch: response.data.data })
    //         // this.state.lovBranch = response.data
    //         // console.log(this.state.lovBranch)
    //         console.log(this.state.lovBranch)
    //     }.bind(this),
    //     error: function (e) {
    //         console.log(e)
    //     }
    // })
    this.setState({ lovBranch: this.state.user.branch });
    console.log(this.state.lovBranch);
  };

  handleInputProduct = (e) => {
    let index = e.target.attributes.getNamedItem("data-index").value;
    let { productList } = this.state;
    productList[index].productName = e.target.value;
    this.setState(productList);
  };

  customerInfo = () => {
    // console.log(this.state.productList);
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Customer
            </label>
            <div className="col-sm-6">
              <input
                type="text"
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="refNumber"
                // placeholder="Skp"
                // onChange={this.handleChangeInput.bind(this)}
                value={this.state.h_name}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Address
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="refNumber"
                // placeholder="Skp"
                // onChange={this.handleChangeInput.bind(this)}
                value={this.state.h_address}
              />
            </div>
          </div>

          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              NPWP/ NIK
            </label>
            <div className="col-sm-5">
              <input
                type="text"
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="refNumber"
                // placeholder="Skp"
                // onChange={this.handleChangeInput.bind(this)}
                value={this.state.h_npwp}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderProduct = () => {
    return this.state.productList.map((item, index) => (
      <div className="form-group row" key={index}>
        <div className="col-sm-10">
          <input
            type="text"
            autoComplete="off"
            className="form-control"
            data-index={index}
            placeholder="Search Product..."
            onChange={this.handleInputProduct.bind(this)}
            value={item.productName}
          />
        </div>
        <div className="col-sm-2">
          <button
            type="button"
            onClick={this.replicateProduct.bind(this)}
            className="btn btn-success"
          >
            +
          </button>{" "}
          &nbsp;
          <button
            type="button"
            onClick={() => {
              this.removeProduct(index);
            }}
            className="btn btn-danger"
          >
            -
          </button>
        </div>
      </div>
    ));
  };

  replicateProduct = () => {
    let { productList } = this.state;
    productList.push({ productName: "", productId: "" });
    this.setState(productList);
  };

  removeProduct = (index) => {
    if (this.state.productList.length === 1) {
      alert("You must have at least 1 product");
      return false;
    }
    let { productList } = this.state;
    productList.splice(index, 1);
    this.setState(productList);
  };

  setChecked = (item) => {
    let find = _.find(this.state.docContainer, function (o) {
      return o.document_id === item.document_id;
    });
    return find ? true : false;
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { documentList } = this.state;
    if (is_checked) {
      documentList.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.documentId) === parseInt(docId);
      });
      documentList.splice(getIndex, 1);
    }
    this.setState(documentList);
  };

  replicateDocument = () => {
    let { documentList } = this.state;
    documentList.push({ documentName: "", documentId: "" });
    this.setState(documentList);
  };

  removeDocument = (index) => {
    if (this.state.documentList.length === 1) {
      alert("You must have at least 1 document");
      return false;
    }
    let { documentList } = this.state;
    documentList.splice(index, 1);
    this.setState(documentList);
  };

  handleInputDocument = (e) => {
    let index = e.target.attributes.getNamedItem("data-index").value;
    let { documentList } = this.state;
    documentList[index].documentName = e.target.value;
    this.setState(documentList);
  };

  renderLovBudget = () => {
    return (
      <select
        className="form-control"
        disabled
        name="budgetType"
        value={this.state.budgetType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Budget -</option>
        {this.state.lovBudget.map((item, index) => (
          <option value={item.budget_type_id} key={index}>
            {item.budget_type}
          </option>
        ))}
      </select>
    );
  };

  renderLovProgram = () => {
    return (
      <select
        className="form-control"
        disabled
        name="programType"
        value={this.state.programType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Program -</option>
        {this.state.lovProgramType.map((item, index) => (
          <option value={item.prog_type_id} key={index}>
            {item.program_name}
          </option>
        ))}
      </select>
    );
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    this.setState({ [name]: value });
    window.setTimeout(() => {
      // console.log(this.state)
    }, 100);
  };

  handleStartDate = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date });
  };

  handleExpDate = (date) => {
    this.setState({ expDate: date });
  };

  resetForm = () => {
    this.setState({
      description: "",
      start_date: new Date(),
      end_date: new Date(),
      claim_exp_date: new Date(),
      program_type_id: "",
      budget_type_id: "",
      budget: 0,
      sales_target: 0,
      program_member_id: "",
      total_participant: "",
      notes: "",
      document_list: [],
    });
  };

  validationForm = () => {
    let count = 0;
    this.setState({ error: [], success: "" });
    if (this.state.principalName === "") {
      ++count;
    } else if (this.state.programType === "") {
      ++count;
    } else if (this.state.budgetType === "") {
      ++count;
    } else if (this.state.budget === 0 || this.state.budget === "") {
      ++count;
    } else if (this.state.salesTarget === 0 || this.state.salesTarget === "") {
      ++count;
    } else if (
      this.state.totalParticipant === 0 ||
      this.state.totalParticipant === ""
    ) {
      ++count;
    } else if (this.state.documentList.length === 0) {
      ++count;
    }

    if (count > 0) {
      this.setState({
        error: [
          "The information you entered is incomplete, please check again",
        ],
      });
      window.scrollTo(0, 0);
      return false;
    } else {
      return true;
    }
  };

  handleApprove = () => {
    this.handleRequestUpdate("A");
  };

  handleReject = () => {
    this.handleRequestUpdate("R");
  };

  handleRequestUpdate = (status) => {
    let custId = "";
    let custName = "";
    let check = true;

    if (this.state.memberType === "Customer") {
      custId = this.state.customerid;
      custName = this.state.oriParticipant;
    } else {
      // alert(typeof this.state.customer.customer_id)
      if (typeof this.customerId === "undefined") {
        alert("Please select the customer");
        check = false;
      } else {
        custId = this.customerId;
        custName = this.customerName;
      }
    }

    if (check == true) {
      // this.checkAlready = 1
      let app = this;
      let findBranch = _.find(this.state.lovBranch, function (o) {
        return parseInt(o.org_id) === parseInt(app.state.cabang_id);
      });
      let branchCode = findBranch ? findBranch.org_name : "";

      let { id } = this.props.match.params;
      let param = {
        program_id: id,
        branch_id: this.state.cabang_id,
        branch_code: branchCode,
        customer_id: custId,
      };

      if (id > 0 && this.state.cabang_id > 0 && custId > 0) {
        let url = "/api/traces/v1/assign/check";

        request.postTraces(url, param, {
          success: function (response) {
            this.checkAlready = parseInt(response.data.data[0].cek);
            // console.log(response.data.data[0].cek)
            // alert(this.checkAlready)

            window.setTimeout(() => {
              if (typeof this.checkAlready != "undefined") {
                if (this.checkAlready === 0) {
                  let app = this;
                  let findBranch = _.find(this.state.lovBranch, function (o) {
                    return parseInt(o.org_id) === parseInt(app.state.cabang_id);
                  });
                  let branchCode = findBranch ? findBranch.org_name : "";
                  let url = "/api/traces/v1/assign/insert";
                  let { id } = this.props.match.params;
                  let param = {
                    program_id: id,
                    branch_id: this.state.cabang_id,
                    branch_code: branchCode,
                    customer_id: custId,
                    customer_name: custName,
                    budget: this.state.budget / this.state.totalParticipant,
                    budget_type: this.state.budgetType,
                    totalParticipant: this.state.totalParticipant,
                    member_name: this.state.programMember_name,
                    user_name: this.state.user.username,
                    source: "arman",
                    menu: "program",
                    function: "assignment",
                  };

                  this.setState({ loading: true });

                  request.postTraces(url, param, {
                    success: function (response) {
                      // let { message } = response.data
                      window.scrollTo(0, 0);
                      this.setState({
                        loading: false,
                        success: "Program has been assigned",
                      });
                      let app = this;
                      window.setTimeout(() => {
                        app.props.history.push("/admin/assign/assign");
                      }, 2000);
                    }.bind(this),
                    error: function (e) {
                      window.scrollTo(0, 0);
                      let error = e.response
                        ? e.response.data.message
                        : "Failed to approve program";
                      this.setState({ loading: false, error: [error] });
                    }.bind(this),
                  });
                } else {
                  alert(
                    "This customer already assigned, please choose other customer"
                  );
                  let app = this;
                  window.setTimeout(() => {
                    app.props.history.push("/admin/assign/assign");
                  }, 2000);
                }
              }
            }, 2000);
          }.bind(this),
          error: function (e) {
            this.checkAlready = 1;
            window.scrollTo(0, 0);
            let error = e.response
              ? e.response.data.message
              : "Fail to connect server.";
            this.setState({ loading: false, error: [error] });
          }.bind(this),
        });
      }
    }
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          {this.state.success}
        </div>
      );
    }
  };

  renderButton = () => {
    if (this.state.is_update) {
      return (
        <div className="col-sm-9">
          <button
            type="button"
            className="btn btn-success"
            onClick={this.handleApprove.bind(this)}
          >
            Assign
          </button>
          &nbsp;
          <button
            type="button"
            className="btn btn-warning"
            onClick={this.handleCancel.bind(this)}
          >
            Cancel
          </button>
        </div>
      );
    } else {
      return (
        <div className="col-sm-9">
          <button
            className="btn btn-warning"
            onClick={this.handleCancel.bind(this)}
          >
            Cancel
          </button>
        </div>
      );
    }
  };

  handleCancel = () => {
    this.props.history.push("/admin/assign/assign");
  };

  renderProductList = () => {
    return (
      <table className="table table-striped table-sm table-bordered">
        <tr className="table-primary">
          <th>Product Description</th>
          <th>Product Reff</th>
          <th>Product Budget</th>
        </tr>
        {this.state.productList.map((item, index) => (
          <tr>
            <td>{item.item_description}</td>
            <td>{item.item_reff}</td>
            <td>{item.item_budget}</td>
          </tr>
        ))}
      </table>
    );
  };

  handleChangeParticipant = (e) => {
    let value = e.target.value;
    this.handleChangeType(value);
  };

  handleChangeType = (value) => {
    let find = _.find(this.state.lovProgramMember, function (o) {
      return o.program_member_id === parseInt(value);
    });
    let type = find ? find.description : "";
    this.setState({ memberId: value, memberType: type });

    let { participant } = this.state;
    participant.customer_id = null;
    participant.participant = null;
    if (type === "Cabang") {
      this.setState({
        showParticipant: true,
        showCabang: true,
        participant,
        branchId: "",
      });
    } else if (type === "Nasional") {
      this.setState({
        showParticipant: true,
        showCabang: false,
        participant,
        selectedBranch: ["0"],
        branchId: "",
      });
    } else {
      this.setState({
        showParticipant: true,
        showCabang: true,
        participant,
        branchId: "",
      });
      let app = this;
      window.setTimeout(() => {
        app.setState({ showParticipant: true });
      }, 200);
    }
  };

  handleEditParticipant = () => {
    this.setState({ showParticipant: true });
    let app = this;
    window.setTimeout(() => {
      app.setState({ showParticipant: true, oriParticipant: "" });
    }, 200);
  };

  handleInputProduct = (e) => {
    let index = e.target.attributes.getNamedItem("data-index").value;
    let { productList } = this.state;
    productList[index].productName = e.target.value;
    this.setState(productList);
  };

  onSelectProduct = (item, index) => {
    let { productList } = this.state;
    productList[index].item_id = item.value;
    productList[index].item_desc = item.text;
  };

  // onSelectProduct = (suggestions, index) => {
  //     let participant = {}
  //     participant.myvalue = (suggestions.value) ? suggestions.value : null
  //     participant.customer_id = this.state.memberType === 'Customer' ? (suggestions.value) ? suggestions.value : null : null
  //     participant.participant = (suggestions.text) ? suggestions.text : null
  //     this.setState({ participant: participant })
  //     console.log(participant)
  // }

  onSelectCustomer = (suggestions, index) => {
    // let customer = {}
    this.customerId = suggestions.value ? suggestions.value : null;
    this.customerName = suggestions.text ? suggestions.text : null;
    // this.setState({ customer : customer })
    // console.log(customerSave)
  };

  // onChangeAutocomplete = (q) => {
  //     let urlOrafin = "/api/orafin/v1/participant"
  //     if (this.state.memberType === 'Channel') {
  //         console.log('Channel')
  //         let url = urlOrafin + "/channel"
  //         let param = {
  //             channel: q
  //         }
  //         let container = []
  //         return new Promise(resolve => {
  //             axios.post(url, param).then(response => {
  //                 var api_response = response.data.data;
  //                 container = api_response.map((item, index) => {
  //                     item.text = item.CHANNEL
  //                     item.value = item.CHANNEL
  //                     return item
  //                 })
  //                 resolve(container);
  //             });
  //         });
  //     } else if (this.state.memberType === 'Customer' || this.state.memberType === 'Nasional' || this.state.memberType === 'Cabang') {
  //         console.log('Customer')
  //         let url = urlOrafin + "/customer"
  //         let param = {
  //             branch_id: this.state.cabang_id,
  //             customer_name: q
  //         }
  //         let container = []
  //         return new Promise(resolve => {
  //             axios.post(url, param).then(response => {
  //                 var api_response = response.data.data;
  //                 container = api_response.map((item, index) => {
  //                     item.text = item.CUSTOMER_NAME
  //                     item.value = item.CUSTOMER_ID
  //                     return item
  //                 })
  //                 resolve(container);
  //             });
  //         });
  //     } else if (this.state.memberType === 'Customer Group') {
  //         console.log('Customer Group')
  //         let url = urlOrafin + "/customer_group"
  //         let param = {
  //             customer_group: q
  //         }
  //         let container = []
  //         return new Promise(resolve => {
  //             axios.post(url, param).then(response => {
  //                 var api_response = response.data.data;
  //                 container = api_response.map((item, index) => {
  //                     item.text = item.CUSTOMER_GROUP
  //                     item.value = item.CUSTOMER_GROUP
  //                     return item
  //                 })
  //                 resolve(container);
  //             });
  //         });
  //     }
  // }

  onChangeAutocompleteCust = (q) => {
    if (
      this.state.memberType === "Customer" ||
      this.state.memberType === "Nasional" ||
      this.state.memberType === "Cabang"
    ) {
      let param = {
        branch_id: this.state.cabang_id,
        customer_name: q,
      };
      let container = [];
      return new Promise((resolve) => {
        request.postOracle("/api/orafin/v1/participant/customer", param, {
          success: function (response) {
            var api_response = response.data.data;
            container = api_response.map((item, index) => {
              item.text = item.CUSTOMER_NAME;
              item.value = item.CUSTOMER_ID;
              return item;
            });
            resolve(container);
          },
          error: function (e) {
            resolve([]);
          },
        });
      });
    } else if (this.state.memberType === "Customer Group") {
      let param = {
        branch_id: this.state.cabang_id,
        group: this.state.oriParticipant,
        customer_name: q,
      };
      let container = [];
      return new Promise((resolve) => {
        request.postOracle(
          "/api/orafin/v1/participant/customer-by-group",
          param,
          {
            success: function (response) {
              var api_response = response.data.data;
              container = api_response.map((item, index) => {
                item.text = item.CUSTOMER_NAME;
                item.value = item.CUSTOMER_ID;
                return item;
              });
              resolve(container);
            },
            error: function (e) {
              resolve([]);
            },
          }
        );
      });
    } else if (this.state.memberType === "Channel") {
      let param = {
        branch_id: this.state.cabang_id,
        group: this.state.oriParticipant,
        customer_name: q,
      };
      let container = [];
      return new Promise((resolve) => {
        request.postOracle(
          "/api/orafin/v1/participant/customer-by-channel",
          param,
          {
            success: function (response) {
              var api_response = response.data.data;
              container = api_response.map((item, index) => {
                item.text = item.CUSTOMER_NAME;
                item.value = item.CUSTOMER_ID;
                return item;
              });
              resolve(container);
            },
            error: function (e) {
              resolve([]);
            },
          }
        );
      });
    }
  };

  handleChangeMultiple = (e) => {
    var options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ selectedBranch: value });
  };

  handleChangeSingle = (e) => {
    var value = e.target.value;
    this.setState({
      selectedBranch: [value],
      branchId: value,
      cabang_id: value,
    });
  };

  renderBranchContainer = () => {
    // if (this.state.showCabang) {
    return (
      <div className="col-md-6">
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
            Branch
          </label>
          <div className="col-sm-9">{this.renderBranch()}</div>
        </div>
      </div>
    );
    // }
  };

  renderBranch = () => {
    return (
      <select
        className="form-control"
        name="branchId"
        value={this.state.cabang_id}
        onChange={this.handleChangeSingle.bind(this)}
      >
        {/* <option value="">- Select Branch -</option> */}
        {this.state.lovBranch.map((item, index) => (
          <option value={item.org_id} key={index}>
            {item.org_name}
          </option>
        ))}
      </select>
    );

    // if (this.state.lovBranch.length > 0)
    // {
    //     return (
    //         <select className="form-control" name="branchId" value={this.state.cabang_id} onChange={this.handleChangeSingle.bind(this)}>
    //             {/* <option value="">- Select Branch -</option> */}
    //             {this.state.lovBranch.map((item, index) => (
    //                 <option value={item.org_id} key={index}>{item.org_name}</option>
    //             ))}
    //         </select>
    //     )
    // }
    // else
    // {
    //     return (
    //         <select disabled className="form-control" name="branchId" value={this.state.cabang_id} onChange={this.handleChangeSingle.bind(this)}>
    //             {this.state.lovBranch.map((item, index) => (
    //                 <option value={item.org_id} key={index}>{item.org_name}</option>
    //             ))}
    //         </select>
    //     )
    // }

    // if (this.state.memberType === 'Cabang' && 1 == 2) {
    //     return (
    //         <select disabled multiple className="form-control select-multiple-height" name="branchId" value={this.state.cabang_id} onChange={this.handleChangeMultiple.bind(this)}>
    //             {this.state.lovBranch.map((item, index) => (
    //                 <option value={item.branch_id} key={index}>{item.branch}</option>
    //             ))}
    //         </select>
    //     )
    // } else {
    //     return (
    //         <select disabled className="form-control" name="branchId" value={this.state.cabang_id} onChange={this.handleChangeSingle.bind(this)}>
    //             <option value="">- Select Branch -</option>
    //             {this.state.lovBranch.map((item, index) => (
    //                 <option value={item.org_id} key={index}>{item.org_name}</option>
    //             ))}
    //         </select>
    //     )
    // }
  };

  renderParticipant = () => {
    // if (this.state.showParticipant) {
    // if (this.state.memberType === 'Customer')
    // {
    return (
      <div className="col-md-6">
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
            Participant
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              disabled
              name="participant"
              className="col-sm-12"
              value={this.state.oriParticipant}
            />
          </div>
        </div>
      </div>
    );

    // }
    // else
    // {
    //     return (
    //         <div className="col-md-6">
    //             <div className="form-group row">
    //                 <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Participant</label>
    //                 <div className="col-sm-9">
    //                     <Autocomplete id="customer_id" onchange={this.onChangeAutocomplete.bind(this)} currentIndex={0} onselect={this.onSelectProduct.bind(this)} />
    //                 </div>
    //             </div>
    //         </div>
    //     )

    // }

    // }
  };

  renderCustomer = () => {
    // if (this.state.showParticipant) {

    if (this.state.memberType === "Customer") {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Customer
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                name="customerName"
                className="col-sm-12"
                value={this.state.oriParticipant}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Customer
            </label>
            <div className="col-sm-9">
              <Autocomplete
                onchange={this.onChangeAutocompleteCust.bind(this)}
                onselect={this.onSelectCustomer.bind(this)}
              />
            </div>
          </div>
        </div>
      );
    }

    // }
  };

  handleRedirect = (e) => {
    const url = request.getFileS3('principal-doc', this.state.fileContainer.filename);
    if (url && url.length > 0) {
      window.open(url, '_blank');
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  {/* <div className="card-header">Form</div> */}
                  <div className="card-body">
                    {this.showSuccess()}
                    {this.showError()}
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Number
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.programNumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Principal
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.principalName}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Reff Number / SKP
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="ref_number"
                                placeholder="Reference Number"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.ref_number}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Type
                            </label>
                            <div className="col-sm-9">
                              {this.renderLovProgram()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Descriptions
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="description"
                                placeholder="Description"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.description}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Budget Type
                            </label>
                            <div className="col-sm-9">
                              {this.renderLovBudget()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Submitted Date
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.submitteddate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Start Date
                            </label>
                            <div className="col-sm-3">
                              <DatePicker
                                selected={this.state.startDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleStartDate}
                                disabled
                              />
                            </div>
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              End Date
                            </label>
                            <div className="col-sm-3">
                              <DatePicker
                                selected={this.state.endDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleEndDate}
                                disabled
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Claim Exp Date
                            </label>
                            <div className="col-sm-9">
                              <DatePicker
                                selected={this.state.expDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleExpDate}
                                disabled
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Budget
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Budget"
                                name="budget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.budget.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Sales Target
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Sales Target"
                                name="salesTarget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.salesTarget.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-8">
                              {this.renderLovPPh()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPh Rate (%)
                            </label>
                            <div className="col-sm-4">
                              <input
                                disabled
                                type="number"
                                max="100"
                                min="0"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder=""
                                name="pphRate"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      {/* <div className="row">
                        <div className="col-md-12">
                          <h5>Customer Info</h5>
                          {this.customerInfo()}
                        </div>
                      </div>
                      <hr /> */}
                      <div className="row">
                        <div className="col-md-8">
                          <h5>Claim Documents</h5>
                          <div className="row">{this.renderDocument()}</div>
                        </div>
                      </div>
                      <hr />
                      <h5>Participants</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Participants Type
                            </label>
                            <div className="col-sm-9">
                              {/* {this.renderLovProgramMember()} */}
                              <input
                                type="text"
                                disabled
                                name="programMember"
                                className="form form-control"
                                value={this.state.programMember_name}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Total Participant
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="number"
                                disabled
                                name="totalParticipant"
                                className="form form-control"
                                value={this.state.totalParticipant}
                                onChange={this.handleChangeInput.bind(this)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {this.renderBranchContainer()}
                        {this.renderParticipant()}
                        {this.renderCustomer()}
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <h5>Products</h5>
                          {this.renderProductList()}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Notes
                            </label>
                            <div className="col-sm-9">
                              <textarea
                                cols="10"
                                rows="5"
                                className="form-control"
                                name="notes"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.notes}
                              ></textarea>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            ></label>
                            {this.renderButton()}
                          </div>
                        </div>
                        <div className="col-md-6">
                          Files:
                          <br />
                          <Link
                            // to={{ pathname: this.state.fileContainer.path }}
                            href=""
                            onClick={this.handleRedirect.bind(this)}
                            target="_blank"
                          >
                            {this.state.fileContainer.filename}
                          </Link>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default AssignDetail;
